// Trigger the most appropriate "rate this app" experience for the current platform.
//
//   1) If a native JavaScript interface is exposed by a custom Android wrapper
//      (`window.Android.requestReview`), call it. This is the path for a WebView-based
//      Android app that uses @JavascriptInterface + ReviewManagerFactory.
//
//   2) Else, if we detect we are running inside a Trusted Web Activity (TWA), navigate
//      to a custom URI scheme that is intercepted by a dedicated ReviewActivity on the
//      Android side. (TWAs cannot expose @JavascriptInterface because they delegate
//      rendering to Chrome, not an in-app WebView.)
//
//   3) Otherwise (desktop, iOS Safari, plain web) → invoke `fallback()` which shows the
//      existing in-app popup component.
//
// `fallback` is required — it preserves the previous behaviour for non-Android users.

const TWA_REVIEW_SCHEME = 'mycompanionai-review://review';

const isLikelyTwa = () => {
  if (typeof document === 'undefined') return false;
  // Chrome sets document.referrer to "android-app://<package>" when launching a TWA.
  return typeof document.referrer === 'string' && document.referrer.startsWith('android-app://');
};

export function triggerInAppReview(fallback) {
  // 1. Native JS interface (WebView-based Android wrapper)
  try {
    if (typeof window !== 'undefined'
        && window.Android
        && typeof window.Android.requestReview === 'function') {
      window.Android.requestReview();
      return 'native';
    }
  } catch (e) {
    // Swallow and continue to next strategy
    // eslint-disable-next-line no-console
    console.warn('[inAppReview] window.Android.requestReview failed:', e);
  }

  // 2. TWA custom URI scheme
  if (typeof window !== 'undefined' && isLikelyTwa()) {
    try {
      window.location.href = TWA_REVIEW_SCHEME;
      return 'twa-scheme';
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('[inAppReview] custom scheme navigation failed:', e);
    }
  }

  // 3. Web/desktop popup fallback
  if (typeof fallback === 'function') {
    fallback();
  }
  return 'fallback';
}
